import { render, staticRenderFns } from "./editPlatform.vue?vue&type=template&id=2cfc20b1&scoped=true&"
import script from "./editPlatform.vue?vue&type=script&lang=js&"
export * from "./editPlatform.vue?vue&type=script&lang=js&"
import style0 from "./editPlatform.vue?vue&type=style&index=0&id=2cfc20b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfc20b1",
  null
  
)

export default component.exports